import React from 'react'
import Layout from '../../Layout/Layout'
import nirric1 from '../../images/nirric1.PNG'

import nirric2 from '../../images/nirric2.PNG'

const NIIRIC_second_gathering = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>NIIRIC 2nd Annual Gathering </h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
                   Convening was scheduled as a specialized event, themed "A Special Dinner, 
                   Networking and Milestones Celebration Night," taking place on November 27, 2025,
                    at The WheatBaker Hotel in Ikoyi, Lagos. The primary focus of the evening was
                     an Interactive Panel Session on NIIRIC's Key Outputs for 2025. The session was
                      organized to bring together the consultants responsible for NIIRIC’s major
                       research work.
</p>

                <p className='light'>The main objective of the panel was to provide participants with
                     a focused overview of NIIRIC’s key knowledge products and their value to ecosystem 
                     players. The session was designed to help attendees understand how to effectively 
                     leverage these resources for various initiatives, including research, policy
                      development, investment decisions, and commercialization strategies. Key outputs
                       highlighted included the Research to Commercialisation Toolkit and the Impact
                        Investing Landscape Study 2025.</p>
               </div>

                <div className='uk-width-1-2@s'>
                 <img src={nirric1} />
               </div>
            </div>







             <div className='uk-grid uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                   <img src={nirric2} />
               </div>

                <div className='uk-width-1-2@s'>
                          <p className='light'>
                            The distinguished panel of speakers featured Prince Ogbonna,
                             CEO of Moolu Ventures, presented the Research to Commercialisation
                              (R2C) Toolkit. Other experts provided insights on reports such 
                              as the Policy Pathways on Impact Investing Report and the Research 
                              and Innovation Industry Brief Report for critical sectors. Each
                               panelist was expected to share brief, practical, and actionable
                                insights from their respective reports, along with strategies 
                                for ecosystem actors to apply the findings in their work.

                            </p>
                  
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default NIIRIC_second_gathering